// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"99d6746f","404":"bcdf3683","787":"0f8d78ff"}[chunkId] + ".chunk.js";
};